// extracted by mini-css-extract-plugin
export default {"separator":"_C5KB6S60WNx7Er1gHeC"};